@if (map !== null) {
  <h4 translate="services.manage.coordinates.title"></h4>
  <app-manage-map-content [serviceId]="serviceId"
    [map]="map"
    [items]="mooringPlacesMapContent"
  (selectedItemEvent)="openMooringPlaceModal($event)"></app-manage-map-content>
}